import { Divider, Link as MUILink, Typography, styled } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NextLink from 'next/link';
import theme from 'src/themes';

export interface IBreadcrumb {
  disabled?: boolean;
  href?: string;
  text: string;
}
type Props = {
  breadcrumbs: IBreadcrumb[];
};

const BreaadCrumbsContainer = styled('div')(() => ({
  backgroundColor: theme.palette.common.white,
}));

export const BasicBreadcrumbs = ({ breadcrumbs }: Props) => {
  return (
    <BreaadCrumbsContainer data-testid="breadcrumbs-container">
      <Breadcrumbs
        sx={{
          maxWidth: theme.breakpoints.values.lg,
          margin: 'auto',
          padding: theme.spacing(2, 2, 2),
        }}
        aria-label="breadcrumb"
      >
        {breadcrumbs.map((breadcrumb) => {
          return breadcrumb.disabled ? (
            <Typography
              color="text.primary"
              key={breadcrumb.text}
              sx={{ fontWeight: 'bold' }}
            >
              {breadcrumb.text}
            </Typography>
          ) : (
            <MUILink
              underline="hover"
              color="inherit"
              component={NextLink}
              href={breadcrumb.href || '#'}
              key={breadcrumb.text}
            >
              {breadcrumb.text}
            </MUILink>
          );
        })}
      </Breadcrumbs>
      <Divider />
    </BreaadCrumbsContainer>
  );
};

export default BasicBreadcrumbs;
